"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridHeaderCheckboxCell = void 0;
const react_1 = __importDefault(require("react"));
const GridHeaderCheckboxCell_1 = require("./components/GridHeaderCheckboxCell/GridHeaderCheckboxCell");
function gridHeaderCheckboxCell(config) {
    return function headerCellRenderer({ column, cellIndex }) {
        if (!config.selectAllEnabled) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement(GridHeaderCheckboxCell_1.GridHeaderCheckboxCell, { key: `header-cell-${cellIndex}-${column.id}`, onClick: config.onClick, checked: config.isChecked() }));
    };
}
exports.gridHeaderCheckboxCell = gridHeaderCheckboxCell;
//# sourceMappingURL=gridHeaderCheckboxCellRenderer.js.map